import styles from './SuccessSummaryHead.module.scss';

export interface Props {
  label: string;
  value: string;
  discount?: boolean;
  isPartial?: boolean;
}

export const SuccessSummaryHead = ({ label, value, isPartial }: Props) => {
  return (
    <>
      <div className={`${styles.row} ${isPartial ? styles.partial : ''}`}>
        <h3>{label}</h3>
        <div className={styles.successfullyPaid}>{value}</div>
      </div>
      <div className={styles.divider} />
    </>
  );
};
